import { render, staticRenderFns } from "./entity-workflow-selector.vue?vue&type=template&id=6b982400&"
import script from "./entity-workflow-selector.vue?vue&type=script&lang=ts&"
export * from "./entity-workflow-selector.vue?vue&type=script&lang=ts&"
import style0 from "./entity-workflow-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports